/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { OrganizationDto } from '../model';
// @ts-ignore
import { OrganizationRegistrationResponse } from '../model';
// @ts-ignore
import { OrganizationResponse } from '../model';
// @ts-ignore
import { OrganizationUpdateDto } from '../model';
/**
 * OrganizationApi - axios parameter creator
 * @export
 */
export const OrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation requests cancel pending organization application (only for updating info request).
         * @summary Cancel Organization Application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrganizationApplication: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/cancel-application`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation creates a pending organization entity in Credify network. This request needs to reviewed by admin.
         * @summary Creates Organization Entity
         * @param {OrganizationDto} organizationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationEntity: async (organizationDto: OrganizationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationDto' is not null or undefined
            assertParamExists('createOrganizationEntity', 'organizationDto', organizationDto)
            const localVarPath = `/v1/entity/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = organizationDto

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves entity encrypted information from Credify DB, which is to be decrypted by the counterpart private key.
         * @summary Gets Organization Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationInfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation deletes a specified account data from Credify network.
         * @summary Removes Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrganization: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation requests updates an organization entity in Credify network.
         * @summary Updates Organization Info
         * @param {OrganizationUpdateDto} organizationUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInfo: async (organizationUpdateDto: OrganizationUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUpdateDto' is not null or undefined
            assertParamExists('updateOrganizationInfo', 'organizationUpdateDto', organizationUpdateDto)
            const localVarPath = `/v1/entity/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = organizationUpdateDto

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationApi - functional programming interface
 * @export
 */
export const OrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         * This operation requests cancel pending organization application (only for updating info request).
         * @summary Cancel Organization Application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrganizationApplication(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrganizationApplication(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation creates a pending organization entity in Credify network. This request needs to reviewed by admin.
         * @summary Creates Organization Entity
         * @param {OrganizationDto} organizationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationEntity(organizationDto: OrganizationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationEntity(organizationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves entity encrypted information from Credify DB, which is to be decrypted by the counterpart private key.
         * @summary Gets Organization Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationInfo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation deletes a specified account data from Credify network.
         * @summary Removes Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOrganization(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeOrganization(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation requests updates an organization entity in Credify network.
         * @summary Updates Organization Info
         * @param {OrganizationUpdateDto} organizationUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationInfo(organizationUpdateDto: OrganizationUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationInfo(organizationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationApi - factory interface
 * @export
 */
export const OrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationApiFp(configuration)
    return {
        /**
         * This operation requests cancel pending organization application (only for updating info request).
         * @summary Cancel Organization Application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrganizationApplication(options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.cancelOrganizationApplication(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation creates a pending organization entity in Credify network. This request needs to reviewed by admin.
         * @summary Creates Organization Entity
         * @param {OrganizationDto} organizationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationEntity(organizationDto: OrganizationDto, options?: any): AxiosPromise<OrganizationRegistrationResponse> {
            return localVarFp.createOrganizationEntity(organizationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves entity encrypted information from Credify DB, which is to be decrypted by the counterpart private key.
         * @summary Gets Organization Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationInfo(options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.getOrganizationInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation deletes a specified account data from Credify network.
         * @summary Removes Organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrganization(options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.removeOrganization(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation requests updates an organization entity in Credify network.
         * @summary Updates Organization Info
         * @param {OrganizationUpdateDto} organizationUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInfo(organizationUpdateDto: OrganizationUpdateDto, options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.updateOrganizationInfo(organizationUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationApi - interface
 * @export
 * @interface OrganizationApi
 */
export interface OrganizationApiInterface {
    /**
     * This operation requests cancel pending organization application (only for updating info request).
     * @summary Cancel Organization Application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApiInterface
     */
    cancelOrganizationApplication(options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation creates a pending organization entity in Credify network. This request needs to reviewed by admin.
     * @summary Creates Organization Entity
     * @param {OrganizationDto} organizationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApiInterface
     */
    createOrganizationEntity(organizationDto: OrganizationDto, options?: AxiosRequestConfig): AxiosPromise<OrganizationRegistrationResponse>;

    /**
     * This retrieves entity encrypted information from Credify DB, which is to be decrypted by the counterpart private key.
     * @summary Gets Organization Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApiInterface
     */
    getOrganizationInfo(options?: AxiosRequestConfig): AxiosPromise<OrganizationResponse>;

    /**
     * This operation deletes a specified account data from Credify network.
     * @summary Removes Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApiInterface
     */
    removeOrganization(options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation requests updates an organization entity in Credify network.
     * @summary Updates Organization Info
     * @param {OrganizationUpdateDto} organizationUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApiInterface
     */
    updateOrganizationInfo(organizationUpdateDto: OrganizationUpdateDto, options?: AxiosRequestConfig): AxiosPromise<OrganizationResponse>;

}

/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
export class OrganizationApi extends BaseAPI implements OrganizationApiInterface {
    /**
     * This operation requests cancel pending organization application (only for updating info request).
     * @summary Cancel Organization Application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public cancelOrganizationApplication(options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).cancelOrganizationApplication(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation creates a pending organization entity in Credify network. This request needs to reviewed by admin.
     * @summary Creates Organization Entity
     * @param {OrganizationDto} organizationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public createOrganizationEntity(organizationDto: OrganizationDto, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).createOrganizationEntity(organizationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves entity encrypted information from Credify DB, which is to be decrypted by the counterpart private key.
     * @summary Gets Organization Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public getOrganizationInfo(options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).getOrganizationInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation deletes a specified account data from Credify network.
     * @summary Removes Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public removeOrganization(options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).removeOrganization(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation requests updates an organization entity in Credify network.
     * @summary Updates Organization Info
     * @param {OrganizationUpdateDto} organizationUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public updateOrganizationInfo(organizationUpdateDto: OrganizationUpdateDto, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).updateOrganizationInfo(organizationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}
